import React, { useState, useEffect } from "react";
import { Col, Row, Modal, Form, Button, Tabs, Tab, TabContainer} from 'react-bootstrap';
import { useSelector } from "react-redux";
import APICom from '../../../utils/helpers/APICom';
import { Icon } from '@iconify/react';



const ColorCodesActions = (props) => {

    const { loginData } = useSelector((store) => store.login);
    const [showColorCodesDialog, setColorCodesDialog] = useState(false);
    const [confimAlert, setConfirmAlert] = useState({ show: false, alertTitle: '', alertMsg: '', btnCancelText: 'No',
    btnOkText: 'Yes', onOkFunction: '' });
    const [selectedBucketColor] = useState('#000000');
    const [selectedPenColor] = useState('#000000');
    const [apiRowData, setApiRowData] = useState([]);
    const [apiColData, setApiColData] = useState([]);
    const [modifiedRowData, setModifiedRowData] = useState([]);
    const [modifiedColData, setModifiedColData] = useState([]);
    const [changeToDefaultFlag, setDefaultFlag] = useState(false);
    const [key, setKey] = useState('gridrow');
    const [noDataAlert, setNoDataAlert] = useState({ alertTitle: '', alertMsg: '' });
    const [displayNoDataAlert, setDisplayNoDataAlert] = useState(false);
    const [iAffiliateIDSelected, setiAffiliateIDSelected] = useState(props.AffiliateIDList.split(',')[0].trim(' '))


    useEffect(() => {
        handleColorCodesDisplay();
    }, []);
    
    const handleColorCodesDisplay = async (e) => {
        try {
            //let iATSPID = loginData ? loginData.iUserAffiliateID.toString() : "-1" ;
            let data = {
                "iATSPID": iAffiliateIDSelected
            }
            let response = await APICom.fetchData("", "TripActions/GetServiceRequestColorCodes", "post", { "Content-Type": "application/json" }, data, null);
            let api_data = response.data.data ? response.data.data : []
            // Elvis operator in ECMAScript 2020
            if (api_data?.length) {
                // array and array.length are truthy
                if (api_data.length === 3)
                {
                    //setting value for row and column cell seperate
                    // index 0 list is row data & index 1 is col. data
                    setApiRowData(api_data[0]);
                    setApiColData(api_data[1]);

                    

                }

              }
            setColorCodesDialog(true);
        }
        catch (err) { console.log(err); }
    }


    const handleRowBucketColorChange = (event, index) => {
        const newColor = event.target.value;
        setApiRowData((prevState) => {
          const updatedRowData = [...prevState];
        //   console.log("**** updatedRowData ****", updatedRowData);
          updatedRowData[index].vHexColorCode = newColor;
          setModifiedRowData(updatedRowData);
          return updatedRowData;
        });
      };
      
    const handleRowPenColorChange = (event, index) => {
        const newColor = event.target.value;
        setApiRowData((prevState) => {
            const updatedRowData = [...prevState];
            // console.log("**** updatedRowData ****", updatedRowData);
            updatedRowData[index].vHexForeColorCode = newColor;
            setModifiedRowData(updatedRowData); 
            return updatedRowData;
        });
    };

    const handleColBucketColorChange = (event, index) => {
        const newColor = event.target.value;
        setApiColData((prevState) => {
          const updatedColData = [...prevState];
        //   console.log("**** updatedColData ****", updatedColData);
          updatedColData[index].vHexColorCode = newColor;
          setModifiedColData(updatedColData);
          return updatedColData;
        });
      };
      
    const handleColPenColorChange = (event, index) => {
        const newColor = event.target.value;
        setApiColData((prevState) => {
            const updatedColData = [...prevState];
            // console.log("**** updatedColData ****", updatedColData);
            updatedColData[index].vHexForeColorCode = newColor;
            setModifiedColData(updatedColData);
            return updatedColData;
        });
    };
    
    
     // Handle Default setting functionality of color change dialog
     const handleColorCodesActionDefault = (e) => {
        // console.log("Color Codes | Default settings invoked");
        setConfirmAlert({show: true, alertTitle:'Confirm Dispatch Default Color', alertMsg:"Are you sure, you want to apply Grid Default Color Settings?", btnCancelText: 'No', btnOkText: 'Yes', onOkFunction: 'applyGridDefaultColorSettings'});
        
    };

    // Handle Default setting functionality of color change dialog
    const handleColorCodesActionSave = (e) => {
        // console.log("Color Codes | Saves invoked");
        setConfirmAlert({show: true, alertTitle:'Confirm Dispatch Color Selection', alertMsg:"Are you sure, you want to save Grid Colors?", btnCancelText: 'No', btnOkText: 'Yes', onOkFunction: 'saveGridColors'});

    };

    
    const UnMountColorCodesComponent = () => {
        if(props.colorCodesComponentLoaded)
          {
            props.setColorCodesComponentLoad(false);
          }
      }

      // Handle cancel functionality of color change dialog
      const handleColorCodesDialogClose = () => {
        try {
            setColorCodesDialog(false);
            UnMountColorCodesComponent();
        } catch (err) {
            console.log(err);
        }
    }


    const applyGridDefaultColorSettings = () => {
        //    console.log("***  applyGridDefaultColorSettings Invoked ***");
           const initialRowData = apiRowData.map((rowData) => ({
            ...rowData,
            vHexColorCode: rowData.vHexColorCodeDefault,
            vHexForeColorCode: rowData.vHexForeColorCodeDefault
        }));

        const initialColData = apiColData.map((colData) => ({
            ...colData,
            vHexColorCode: colData.vHexColorCodeDefault,
            vHexForeColorCode: colData.vHexForeColorCodeDefault
        }));

        setApiRowData(initialRowData);
        setApiColData(initialColData);
        setDefaultFlag(true);
    }

    const saveGridColors = async (e) => {
        try {
            if(changeToDefaultFlag)
            {
                const modifiedRowList = apiRowData.map((rowData) => ({
                    iID: parseInt(rowData.iID),
                    foreColor: rowData.vHexForeColorCode || selectedPenColor,
                    backColor: rowData.vHexColorCode || selectedBucketColor,
                }));
    
                const modifiedColList = apiColData.map((colData) => ({
                    iID: parseInt(colData.iID),
                    foreColor: colData.vHexForeColorCode || selectedPenColor,
                    backColor: colData.vHexColorCode || selectedBucketColor,
                }));
                const modifiedList = [...modifiedRowList, ...modifiedColList].map((dataItem) => ({
                    iID: parseInt(dataItem.iID),
                    foreColor: dataItem.foreColor || selectedPenColor,
                    backColor: dataItem.backColor || selectedBucketColor,
                }));
                //let iATSPID = loginData ? loginData.iUserAffiliateID.toString() : "-1" ;
                let data = {
                    "iATSPID": iAffiliateIDSelected,
                    "iMode": "4",
                    "colorSettings":modifiedList
                }
                let response = await APICom.fetchData("", "TripActions/SaveUpdateDispatchColors", "post", { "Content-Type": "application/json" }, data, null);
                let api_data = response.data;
                if (api_data)
                {
                    setNoDataAlert({
                        alertTitle: api_data.data === 1 ? 'Save Successful' : 'Save Failed',
                        alertMsg: api_data.data === 1  ? 'Grid Colors Save Successfully.' : 'An Error Occurred.'
                    });
                    setDisplayNoDataAlert(true);
                    props.ReloadDataFunction();
                    setDefaultFlag(false);
                }
                else
                {
                    setNoDataAlert({
                        alertTitle: 'Save Failed',
                        alertMsg: 'An Error Occurred. Network unreachable.'
                    });
                }
                setDisplayNoDataAlert(true);
            }
            else
            {
                const modifiedRowList = modifiedRowData.map((rowData) => ({
                    iID: parseInt(rowData.iID),
                    foreColor: rowData.vHexForeColorCode || selectedPenColor,
                    backColor: rowData.vHexColorCode || selectedBucketColor,
                }));
    
                const modifiedColList = modifiedColData.map((colData) => ({
                    iID: parseInt(colData.iID),
                    foreColor: colData.vHexForeColorCode || selectedPenColor,
                    backColor: colData.vHexColorCode || selectedBucketColor,
                }));
                const modifiedList = [...modifiedRowList, ...modifiedColList].map((dataItem) => ({
                    iID: parseInt(dataItem.iID),
                    foreColor: dataItem.foreColor || selectedPenColor,
                    backColor: dataItem.backColor || selectedBucketColor,
                }));
                //let iATSPID = loginData ? loginData.iUserAffiliateID.toString() : "-1" ;
                let data = {
                    "iATSPID": iAffiliateIDSelected,
                    "iMode": "4",
                    "colorSettings":modifiedList
                }
                let response = await APICom.fetchData("", "TripActions/SaveUpdateDispatchColors", "post", { "Content-Type": "application/json" }, data, null);
                let api_data = response.data;
                if (api_data)
                {
                    setNoDataAlert({
                        alertTitle: api_data.data === 1 ? 'Save Successful' : 'Save Failed',
                        alertMsg: api_data.data === 1  ? 'Grid Colors Save Successfully.' : 'An Error Occurred.'
                    });
                    setDisplayNoDataAlert(true);
                    props.ReloadDataFunction();
                }
                else
                {
                    setNoDataAlert({
                        alertTitle: 'Save Failed',
                        alertMsg: 'An Error Occurred. Network unreachable.'
                    });
                }
                setDisplayNoDataAlert(true);
            }
            
        } catch (err) {
            console.log(err);
        }
        };
          

    var handleConfirmOkFunction = () => {
        switch(confimAlert.onOkFunction) {
            case "applyGridDefaultColorSettings":
                applyGridDefaultColorSettings();
                break;
            case "saveGridColors":
                saveGridColors();
                break;
            default:
                console.log("No function assigned to confirmation dialog for ok/yes");
                break;
        }
    }
    const handleConfirmOk = () => {
        setConfirmAlert((prevState) => ({...prevState, show:false}));
        handleConfirmOkFunction();
    }

    const handleConfirmCancel = () => {
        setConfirmAlert((prevState) => ({...prevState, show:false}));
    }
    const handleAlertModalClose = () => {
        setDisplayNoDataAlert(false);
    }

   
    return (
        <>
            {showColorCodesDialog &&
                <Modal centered show={showColorCodesDialog} onHide={handleColorCodesDialogClose} animation={false}>
                    <Modal.Header className='activate_dialog_header_bgcolor' style={{ height: "50px" }} closeButton>
                        <Modal.Title className='activate_dialog_title_color user-select-none'>Dispatch Grid Color Codes</Modal.Title>
                    </Modal.Header>
                    <Modal.Body className="user-select-none">
                        <Tabs
                            id="controlled-tab-example"
                            activeKey={key}
                            onSelect={(k) => setKey(k)}
                            className="mb-3"
                            >
                            <Tab eventKey="gridrow" title="Grid Row Color">
                                <TabContainer>
                                    <Row>
                                        <Col sm={8}>
                                        </Col>
                                        <Col sm={2}>
                                            <center><Icon icon="tabler:bucket-droplet" /></center>
                                        </Col>
                                        <Col sm={2}>
                                            <center><Icon icon="tabler:pencil" /></center>
                                        </Col>
                                    
                                    </Row>
                                    {apiRowData.map((rowData, index) => (
                                            <Row key={index}>
                                                <Col sm={8}>
                                                    {/* Color Preview */}
                                                    <div style={{ fontSize: '15px', textAlign: 'center', backgroundColor: rowData.vHexColorCode || selectedBucketColor, padding: '2%', color: rowData.vHexForeColorCode|| selectedPenColor }}>{rowData.vDisplayName}</div>
                                                </Col>
                                                <Col sm={2}>
                                                    {/* Background Color Picker */}
                                                    <center>
                                                        <Form.Control
                                                            type="color"
                                                            title={"Background Color ["+(rowData.vHexColorCode || selectedBucketColor)+"]"}
                                                            value={rowData.vHexColorCode || selectedBucketColor}
                                                            onChange={(event) => handleRowBucketColorChange(event, index)}
                                                        />
                                                    </center>
                                                    
                                                </Col>
                                                <Col sm={2}>
                                                    {/* Font Color Picker */}
                                                    <center>
                                                        <Form.Control
                                                            type="color"
                                                            title={"Text Color ["+(rowData.vHexForeColorCode || selectedPenColor)+"]"}
                                                            value={rowData.vHexForeColorCode || selectedPenColor}
                                                            onChange={(event) => handleRowPenColorChange(event, index)}
                                                        />
                                                    </center>
                                                </Col>
                                            </Row>
                                        ))}

                                </TabContainer>
                             </Tab>
                            <Tab eventKey="gridcol" title="Grid Col. Cell Color">
                                <TabContainer>
                                    <Row>
                                        <Col sm={8}>
                                        </Col>
                                        <Col sm={2}>
                                            <center><Icon icon="tabler:bucket-droplet" /></center>
                                        </Col>
                                        <Col sm={2}>
                                            <center><Icon icon="tabler:pencil" /></center>
                                        </Col>
                                    
                                    </Row>
                                    {apiColData.map((colData, index) => (
                                            <Row key={index}>
                                                <Col sm={8}>
                                                    {/* Color Preview */}
                                                    <div style={{fontSize: '15px', textAlign: 'center', backgroundColor: colData.vHexColorCode || selectedBucketColor, padding: '2%', color: colData.vHexForeColorCode|| selectedPenColor }}>{colData.vDisplayName}</div>
                                                </Col>
                                                <Col sm={2}>
                                                    {/* Background Color Picker */}
                                                    <center>
                                                        <Form.Control
                                                            type="color"
                                                            title={"Background Color ["+(colData.vHexColorCode || selectedBucketColor)+"]"}
                                                            value={colData.vHexColorCode || selectedBucketColor}
                                                            onChange={(event) => handleColBucketColorChange(event, index)}
                                                        />
                                                    </center>
                                                </Col>
                                                <Col sm={2}>
                                                    {/* Font Color Picker */}
                                                    <center>
                                                        <Form.Control
                                                            type="color"
                                                            title={"Text Color ["+(colData.vHexForeColorCode || selectedPenColor)+"]"}
                                                            value={colData.vHexForeColorCode || selectedPenColor}
                                                            onChange={(event) => handleColPenColorChange(event, index)}
                                                        />
                                                    </center>
                                                </Col>
                                            </Row>
                                        ))}
                                </TabContainer>
                            </Tab>
                        </Tabs>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button className="tripaction_btn_color" onClick={handleColorCodesActionDefault}>
                            Default Setting
                        </Button>
                        <Button className="tripaction_btn_color" onClick={handleColorCodesActionSave}>
                            Save
                        </Button>
                        <Button variant="secondary" onClick={handleColorCodesDialogClose}>
                            Cancel
                        </Button>
                    </Modal.Footer>
                </Modal>}
            {confimAlert.show && <Modal centered show={confimAlert.show} onHide={handleConfirmCancel} animation={false}>
                <Modal.Header className='noshow_dialog_header_bgcolor' style={{ height: "50px" }} closeButton>
                    <Modal.Title className='noshow_dialog_title_color'>{confimAlert.alertTitle}</Modal.Title>
                </Modal.Header>
                <Modal.Body><b>{confimAlert.alertMsg}</b></Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleConfirmCancel}>
                        No
                    </Button>
                    <Button variant="secondary" onClick={handleConfirmOk}>
                        Yes
                    </Button>
                </Modal.Footer>
            </Modal>}
            {displayNoDataAlert && <Modal centered show={displayNoDataAlert} onHide={handleAlertModalClose} animation={false}>
                <Modal.Header className='noshow_dialog_header_bgcolor' style={{ height: "50px" }} closeButton>
                    <Modal.Title className='noshow_dialog_title_color'>{noDataAlert.alertTitle}</Modal.Title>
                </Modal.Header>
                <Modal.Body><b>{noDataAlert.alertMsg}</b></Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleAlertModalClose}>
                        Close
                    </Button>
                </Modal.Footer>
            </Modal>}
           
        </> 
    );
}

export default ColorCodesActions;